import { createRemediationRule } from '../rule-factory/create-remediation-rule';

export const ariaEditorRule = (): void => {};

const updateAriaHidden = (): void => {};

const updateTabindex = (): void => {};

export const AriaEditorRule = createRemediationRule({
  ruleId: 'aria-editor',
  rule: ariaEditorRule,
  postMessageApi: {
    'update-aria-hidden': updateAriaHidden,
    'update-tabindex': updateTabindex,
  },
});
